// Ensure the script only runs once, even if it's included multiple times
if (!window.triptychScriptLoaded) {
    window.triptychScriptLoaded = true; // Set the flag so the script doesn't run again

  // Get all elements with the class 'triptych__block'
  var triptychBlocks = document.querySelectorAll('.triptych__block');
  
  // Add click event listener to each triptych block
  triptychBlocks.forEach(function(block) {
      // Add click event listener to the triptych block
      block.addEventListener('click', function(event) {
          // Find the anchor element within the triptych block
          var anchor = block.querySelector('.triptych__block-text-container a');
  
          // Check if an anchor element exists within the triptych block
          if (anchor) {
              // Prevent the default action of the click event
              event.preventDefault();
  
              // Get the URL from the anchor element
              var url = anchor.getAttribute('href');
  
              // Navigate to the URL
              window.location.href = url;
          }
      });
  });
  
  // DYNAMIC TEXT BLOCK
  document.addEventListener('DOMContentLoaded', function () {
      const flipContainers = document.querySelectorAll('.dynamic-message-container'); // Select all instances
  
      flipContainers.forEach(function(flipContainer) {
          console.log(flipContainer); // Ensure the correct element is selected
      });
  
      flipContainers.forEach(function(flipContainer) {
          const front = flipContainer.querySelector('.front');
          const back = flipContainer.querySelector('.back');
  
          // Collect the dynamic message parts and their colors from the data attributes, only if they are not empty
          const messages = [
              { text: flipContainer.getAttribute('data-message-part-1'), color: flipContainer.getAttribute('data-part-1-color') },
              { text: flipContainer.getAttribute('data-message-part-2'), color: flipContainer.getAttribute('data-part-2-color') },
              { text: flipContainer.getAttribute('data-message-part-3'), color: flipContainer.getAttribute('data-part-3-color') },
              { text: flipContainer.getAttribute('data-message-part-4'), color: flipContainer.getAttribute('data-part-4-color') },
              { text: flipContainer.getAttribute('data-message-part-5'), color: flipContainer.getAttribute('data-part-5-color') }
          ].filter(message => message.text && message.text.trim() !== ''); // Filter out any blank or empty strings
  
          // If no valid messages, stop further execution for this container
          if (messages.length === 0) return;
  
          let currentIndex = 0;
  
          // Function to flip the card and update content
          function flipCard() {
              // Update index first before flipping to the next message
              currentIndex = (currentIndex + 1) % messages.length;
  
              //console.log('Before flip:', flipContainer.classList.contains('flip')); // Check if 'flip' is applied before
                          
              // Toggle flip class
              flipContainer.classList.toggle('flip');

              //console.log('After flip:', flipContainer.classList.contains('flip')); // Check if 'flip' is applied after
  
              // Update content based on the flip state
              if (flipContainer.classList.contains('flip')) {
                  // Back is coming into view, so update its content
                  back.textContent = messages[currentIndex].text;
                  back.style.color = messages[currentIndex].color; // Update color for back
              } else {
                  // Front is coming into view, so update its content
                  front.textContent = messages[currentIndex].text;
                  front.style.color = messages[currentIndex].color; // Update color for front
              }
          }
        
          // Set an interval to flip every 3 seconds
          setInterval(flipCard, 3000);
      });
  });
  
  
  
  document.querySelectorAll('.triptych__block').forEach(block => {
    // Apply hover effects on desktop (mouse events)
    block.addEventListener('mouseenter', function() {
      applyFilters(block);
      toggleTrypticImageEffect(block, true); // Simulate hover effect for ::after
    });
    
    block.addEventListener('mouseleave', function() {
      resetFilters(block);
      toggleTrypticImageEffect(block, false); // Remove hover effect for ::after
    });
  
    // Apply touch support for mobile devices
    block.addEventListener('touchstart', function() {
      applyFilters(block);
      toggleTrypticImageEffect(block, true); // Simulate hover effect for ::after
    });
  
    block.addEventListener('touchend', function() {
      resetFilters(block);
      toggleTrypticImageEffect(block, false); // Remove hover effect for ::after
    });
  });
  
  // Function to apply filters
  function applyFilters(block) {
    const draggableImage = block.querySelector('.draggable-element');
    const draggableText = block.querySelector('.draggable-text');
    
    // Handle image filter
    if (draggableImage) {
      const originalFilter = getComputedStyle(draggableImage).filter;
      draggableImage.setAttribute('data-original-filter', originalFilter);
      /* kill this line below to remove the additional filtering*/
      /* draggableImage.style.filter = `${originalFilter} saturate(50%) brightness(80%)`;*/
    }
  
    // Handle text filter
    if (draggableText) {
      const originalFilter = getComputedStyle(draggableText).filter;
      draggableText.setAttribute('data-original-filter', originalFilter);
      /* kill this line below to remove the additional filtering*/
      /*draggableText.style.filter = `${originalFilter} saturate(50%) brightness(80%)`;*/
    }
  }
  
  // Function to reset filters
  function resetFilters(block) {
    const draggableImage = block.querySelector('.draggable-element');
    const draggableText = block.querySelector('.draggable-text');
  
    // Reset image filter
    if (draggableImage) {
      const originalFilter = draggableImage.getAttribute('data-original-filter');
      draggableImage.style.filter = originalFilter ? originalFilter : 'none';
    }
  
    // Reset text filter
    if (draggableText) {
      const originalFilter = draggableText.getAttribute('data-original-filter');
      draggableText.style.filter = originalFilter ? originalFilter : 'none';
    }
  }
  
  // Function to toggle triptych__block-image hover effect
  function toggleTrypticImageEffect(block, isActive) {
    const triptychImage = block.querySelector('.triptych__block-image');
    
    if (triptychImage) {
      if (isActive) {
        triptychImage.classList.add('hovered'); // Add hover class
      } else {
        triptychImage.classList.remove('hovered'); // Remove hover class
      }
    }
  }

}

/*document.addEventListener('DOMContentLoaded', function () {
  var draggableImage = document.querySelector('.draggable-image');

  if (draggableImage) {
    draggableImage.addEventListener('mousedown', function (e) {
      var offsetX = e.clientX - draggableImage.offsetLeft;
      var offsetY = e.clientY - draggableImage.offsetTop;

      function moveAt(e) {
        var newTop = e.clientY - offsetY;
        var newLeft = e.clientX - offsetX;

        // Update style dynamically to simulate dragging
        draggableImage.style.top = `${newTop}px`;
        draggableImage.style.left = `${newLeft}px`;
      }

      document.addEventListener('mousemove', moveAt);

      draggableImage.onmouseup = function () {
        document.removeEventListener('mousemove', moveAt);
        draggableImage.onmouseup = null;
      };
    });
  }
});*/